import { CA } from '../../../../shared/scripts/analytics/Analytics.ts';
import { setElementOnClick } from '../../../../shared/scripts/ui_utils/DomUtils.ts';
import { Scene } from '../UISceneTypes.ts';
import { MatchmakingCardCategory } from '../../../../shared/scripts/ui_html/home_page/ModeSelectorTypes.ts';
import { AnalyticEventType, AnalyticEventCategory } from '../../../../../shared/entity_datas/EntityDatas.ts';
import { AudioManager, AudioType } from '@colonist/audio';
import { UILanguageButtonController } from '../../../../shared/scripts/ui_popup/ui_language/UILanguageButtonController.ts';
import { UIPopupRulebook } from '../../../../shared/scripts/ui_popup/UIPopupRulebook.ts';
import { RulebookPage } from '../../../../../shared/enums/RulebookEnums.ts';
import { UIUtilsEjsVariables } from '../../../../shared/scripts/UIUtilsEjsVariables.ts';
export class UILandingPageController {
    clickPlayWithFriendsCTA() {
        AudioManager.play(AudioType.Click);
        void CA.sendAnalyticEvent({
            type: AnalyticEventType.ClickedLandingPagePlayWithFriends,
            category: AnalyticEventCategory.LandingPage
        });
        this.uiManager.sceneController.loadScene(Scene.Lobby);
    }
    clickPlayOnlineCTA() {
        AudioManager.play(AudioType.Click);
        void CA.sendAnalyticEvent({
            type: AnalyticEventType.ClickedLandingPageExploreModes,
            category: AnalyticEventCategory.LandingPage
        });
        this.uiManager.modeSelector.selectTab(MatchmakingCardCategory.Bots);
        this.uiManager.sceneController.loadScene(Scene.MainPage);
    }
    // eslint-disable-next-line class-methods-use-this
    clickPlayOnMobileWebCTA() {
        AudioManager.play(AudioType.Click);
        void CA.sendAnalyticEvent({
            type: AnalyticEventType.ClickedLandingPagePlayOnMobileWeb,
            category: AnalyticEventCategory.LandingPage
        });
        // eslint-disable-next-line no-restricted-syntax
        window.location.href = '/mobile';
    }
    // eslint-disable-next-line class-methods-use-this
    async clickAppBannerButton() {
        AudioManager.play(AudioType.Click);
        await CA.sendAnalyticEvent({
            type: AnalyticEventType.ClickedLandingPageOpenApp,
            category: AnalyticEventCategory.LandingPage
        });
        // Must be the colonist.io URL, otherwise Universal Deeplink will not be triggered
        // eslint-disable-next-line no-restricted-syntax
        window.location.href = 'https://colonist.io/open-app';
    }
    hide() {
        if (this.landingPageContainerDiv != undefined) this.landingPageContainerDiv.style.display = 'none';
    }
    show() {
        if (this.landingPageContainerDiv != undefined) this.landingPageContainerDiv.style.display = 'flex';
    }
    static setupLandingPageTracking() {
        const languageButton = document.getElementById('landingpage-language-button');
        const footerRulesButton = document.getElementById('footer-rules-button');
        const footerPrivacyButton = document.getElementById('footer-privacy-policy-button');
        // eslint-disable-next-line no-restricted-syntax
        languageButton.addEventListener('click', ()=>{
            void CA.sendAnalyticEvent({
                type: AnalyticEventType.ClickedLandingPageLanguageSelector,
                category: AnalyticEventCategory.LandingPage
            });
        });
        // eslint-disable-next-line no-restricted-syntax
        footerRulesButton.addEventListener('click', ()=>{
            void CA.sendAnalyticEvent({
                type: AnalyticEventType.ClickedLandingPageFooterRules,
                category: AnalyticEventCategory.LandingPage
            });
            if (UIUtilsEjsVariables.isUserOnDiscord) {
                new UIPopupRulebook(RulebookPage.Classic4P).show();
            }
        });
        // eslint-disable-next-line no-restricted-syntax
        footerPrivacyButton.addEventListener('click', ()=>{
            void CA.sendAnalyticEvent({
                type: AnalyticEventType.ClickedLandingPageFooterPrivacy,
                category: AnalyticEventCategory.LandingPage
            });
        });
    }
    constructor(uiManager){
        this.uiManager = uiManager;
        this.landingPageContainerDiv = document.getElementById('scene_landing_page_container');
        this.playWithFriendsCTA = document.getElementById('landingpage_cta_playwithfriends');
        const playOnlineCTA = document.getElementById('landingpage_cta_playonline');
        const playOnMobileWebCTA = document.getElementById('landingpage_cta_playonweb');
        const appBannerButton = document.getElementById('app_banner_open_app_button');
        setElementOnClick(this.playWithFriendsCTA, ()=>this.clickPlayWithFriendsCTA());
        setElementOnClick(playOnlineCTA, ()=>this.clickPlayOnlineCTA());
        setElementOnClick(playOnMobileWebCTA, ()=>this.clickPlayOnMobileWebCTA());
        setElementOnClick(appBannerButton, ()=>void this.clickAppBannerButton());
        new UILanguageButtonController(this.landingPageContainerDiv);
        UILandingPageController.setupLandingPageTracking();
    }
}
